<template>
  <div class="services d-flex flex-column align-center justify-center mt-6 mb-6 py-10 rounded-lg">
    <SectionTitle title="Our Services" />
    <div class="d-flex  align-items-center flex-row justify-space-around flex-wrap flex-lg-nowrap">
      <div v-for="(service, index) in services"
           :key="index">
        <ServiceCard :service="service" />
      </div>

    </div>
    <CTA :actionButtonText="actionButtonText"
         :density="display.mobile ? 'compact' : 'default'"
         :to="'#contact-form'"
         class="my-4" />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onBeforeUnmount, ref } from 'vue';
import { useDisplay } from 'vuetify';
import type { ServiceModel } from '~/models/serviceModel';
import SectionTitle from './sectionTitle.vue';

const display = ref(useDisplay());
const observer = ref<IntersectionObserver | null>(null);

const actionButtonText = computed(() => (display.value.mobile ? 'Schedule Now' : 'Schedule your consultation'));
function addCardsToObserver() {
  const cards = document.querySelectorAll('.services .v-card');
  observer.value = new IntersectionObserver((entries) => {
    entries.reverse().forEach((entry) => {
      if (entry.isIntersecting) {
        const index = Array.from(cards).indexOf(entry.target);
        (entry.target as HTMLElement).style.transitionDelay = `${index * 0.4}s`; // Add delay based on index
        entry.target.classList.add('in-view');
      }
    });
  });

  cards.forEach((card) => {
    observer.value?.observe(card);
  });
}
onMounted(() => {
  console.log(display.value.xlAndUp);

  if (window.innerHeight > 950) addCardsToObserver();
  else window.addEventListener('scroll', addCardsToObserver);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', addCardsToObserver);
  observer.value?.disconnect(); // Cleanup observer
});

const services: ServiceModel[] = [
  {
    title: "Doors and Walls",
    image: "/walls.jpg",
    alt: "Doors and Walls",
    to: null,
    description: "Upgrade your home or business with our premium door and wall glass solutions. We specialize in durable, energy-efficient glass that enhances aesthetics. Our expert craftsmanship ensures a perfect fit, adding value and style to any space."
  },
  {
    title: "Exterior Glass",
    image: "/exterior.jpeg",
    alt: "Exterior Glass",
    to: null,
    description: "Enhance your building's exterior with custom glass installations designed for durability and style. Our exterior glass solutions provide superior insulation, natural light, and a modern look, making your property stand out."
  },
  {
    title: "Shower Enclosures",
    image: "/shower.jpg",
    alt: "Shower Enclosures",
    to: null,
    description: "Transform your bathroom with our elegant and functional shower enclosures, tailored to your needs. Our designs combine luxury and practicality, offering a seamless blend of beauty and durability for your space."
  }
];
</script>

<style scoped>
.services .v-card {
  opacity: 0;
  transform: translateY(50px) translateX(-50px);
  /* Start slightly off-screen */
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.services .v-card.in-view {
  opacity: 1;
  transform: translateY(0) translateX(0);
  /* Slide into place */
}

@media screen and (max-width: 600px) {
  .services .v-card {
    transform: translateY(50px);
  }
}
</style>